import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface TextInputFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function TextInputField({ field, value, onChange }: TextInputFieldProps) {
  const config = field.config;

  return (
    <input
      id={field.id}
      type={field.type}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={config.placeholder}
      required={config.required}
      minLength={config.minLength}
      maxLength={config.maxLength}
      min={config.min}
      max={config.max}
      step={config.step}
      pattern={config.pattern}
      disabled={field.type === 'hidden'}
      className={cn(
        "easyforms-field-input",
        field.type === 'hidden' && "hidden"
      )}
    />
  );
}
